import { oauth2Instance } from '../../../common/services';
import { getAttributionParams, clearAttributionParams } from '../../../common/services/utmParams';

//Send OTP to phone number
export async function sendApplyOnlineOtp(phoneNumber) {
  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/token/generate-otp`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        mobile_number: phoneNumber,
        OTPPurpose: 'apply-online-request'
      })
    }
  );
  if (!response.ok) {
    throw new Error('Failed to send OTP. Please try again.');
  }
  return response.json();
}

//Verify OTP
export async function verifyApplyOnlineOtp(otp, phoneNumber) {
  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/token/validate-otp`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        OTP: otp,
        mobile_number: phoneNumber
      })
    }
  );
  if (!response.ok) {
    throw new Error('Invalid OTP. Please try again.');
  }
  return response.json();
}

//Submit to Liferay Object
export async function submitApplyOnlineRequest(formData) {
  const preparedData = {
    fullName: formData.fullName,
    emailId: formData.emailId,
    pincode: formData.pincode,
    loanType: formData.loanType,
    phoneNumber: formData.phoneNumber,
    ...getAttributionParams(),
  };

  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/scl-forms/save-apply-Online`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(preparedData)
    }
  );
  const responseBody = await response.json(); // parse JSON regardless of status

  if (!response.ok || !responseBody.success) {
    throw new Error(responseBody.message || 'Form submission Failed');
  }

  // Lead submitted successfully -> consume the captured attribution
  clearAttributionParams();

  return responseBody;
}
